@use "../partials/colors-ev";
@use "../partials/mixins";

$input-height: 48px;

// https://github.com/vercel/next.js/discussions/19417
// https://vitejs.dev/guide/features

[class~='MuiSkeleton-root'] {
  background-color: colors-ev.$merino;
}

.chip__count {
  background-color: colors-ev.$merino;

  [class~="MuiChip-label"] {
    //background-color: colors-ev.$crimson;
  }
}

// non-autocomplete dropdowns (structure is so different, so separate the styles)
.dd_select {

  // top position for label different when expanded vs closed (else label is at bottom of field)
  label:not([class~=Mui-focused]):not([data-shrink="true"]) {
    // re-center text in non-focused input due to smaller height
    @apply -top-1 text-carbon;
  }

  [class~=MuiInputBase-root] {
    height: $input-height !important;
    // content-center = needed to vertically align chips (multi-select) or others in dropdown
    @apply rounded-none content-center flex-nowrap;
  }

  fieldset[class~=MuiOutlinedInput-notchedOutline] {
    @apply border-carbon border-opacity-25 text-carbon;
  }

  // main select element
  [class~=MuiSelect-outlined] {
    // prevent overflow when multiple selected elements
    @apply flex;
  }
}

// the popper paper when clicking the select dropdown
.popper_select {
  // prevent popper from taking up all height, thus making it difficult to close the popper
  [class~=MuiPaper-root] {
    @apply max-h-96 rounded-none text-carbon;
  }

  // ripple animation when clicking a MenuItem
  [class~=MuiTouchRipple-child] {
    @apply bg-merino-600;
  }
}

// autocomplete dropdowns (much more complex structure)
.dd_autocomplete {
  // autocomplete -- they have different structure
  [class~=MuiInputBase-root] {
    // small = 39px
    height: $input-height !important;
    // content-center = needed to vertically align chips (multi-select) or others in dropdown
    @apply rounded-none content-center flex-nowrap;
  }

  label[class~=MuiInputLabel-root] {
    @apply text-carbon;
    &[data-shrink='false'] {
      @apply text-base pr-3;
    }
  }

  // when dropdown is NOT expanded, apply top .25rem to center placeholder
  &:not([class~=Mui-expanded]) {
    // set top 4px ONLY when shrink is false, meaning when there's no value selected;
    // shrink = label moved to top left upper position
    label[class~=MuiInputLabel-root][data-shrink='false'] {
      @apply top-1;
    }
  }

  fieldset {
    @apply border-carbon border-opacity-25 text-carbon;
  }

  // autocomplete
  [class~=Mui-focused] {
    fieldset[class~=MuiOutlinedInput-notchedOutline] {
      @apply border-carbon text-carbon;
    }
  }

  [class~=MuiAutocomplete-clearIndicator], [class~=MuiAutocomplete-popupIndicator] {
    @apply hover:text-carbon;
  }
}

// customize look of popover component that opens when clicking inside the field
.popper_autocomplete {
  [class~=MuiPaper-root] {
    @apply rounded-none;
  }

  // autocomplete, select
  ul[class~=MuiAutocomplete-listbox], ul[class~=MuiList-root] {

    // default select (non-autocomplete)
    [class~=MuiMenuItem-root] {
      &[class~=Mui-selected], &:hover {
        @apply bg-merino;
      }
    }

    // autocomplete dropdown
    li[class~=MuiAutocomplete-option] {
      &[aria-selected=true], &[class~=Mui-focused] {
        @apply bg-merino;
      }
    }
  }
}

// styling of rendered tags in autocomplete when multiple items selected
.dd_autocomplete_tags {
  @apply overflow-hidden text-ellipsis whitespace-nowrap w-72 pl-2;
}

.dd_select_tags {
  @apply overflow-hidden text-ellipsis whitespace-nowrap w-72 pl-2;
}

// chips for user selection per filter type
.filter_chips {
  @apply mt-1 gap-1 flex flex-wrap;
  [class~=MuiChip-root] {
    @apply bg-merino;
  }
}

// button to trigger slider filter for price
.price_slider_btn {
  @apply w-full justify-start;
  @include mixins.ev-button;
}

.btn_clear_filters {
  @apply w-full justify-start;
  @include mixins.ev-button;

  // properly center icon
  [class~=MuiButton-icon] {
    @apply mx-0;
  }
}

// specific style overrides for search bar
.search_bar {
  @apply bg-white border-b border-carbon border-solid;
  fieldset {
    @apply border-none;
  }
}

// Elastic SearchUI React module -- input search box
.es_search_input {
  @apply w-full;
}

// Elastic SearchUI React module -- autocomplete popper
.es_search_autocomplete {
  //@apply flex w-full lg:w-1/2 self-center *:text-left list-none;
  @apply flex w-full self-center *:text-left list-none;
  // note: override styles from default SearchUI stylesheets
  left: 0 !important;
  right: auto !important;
  z-index: 50 !important;
  border-radius: 0 !important;
  background: colors-ev.$merino !important;
  border: none !important;
  padding: 0 !important;

  // individual autocomplete suggestions
  a {
    @apply p-0 px-2 py-1;

    // remove inner padding/margin
    [class~=MuiListItemText-root] {
      @apply m-0 p-0;
    }

    // remove this useless ripple effect when clicking the suggestion
    [class~=MuiTouchRipple-root] {
      @apply hidden;
    }
  }
}

// toggle btn group for maps vs grid
.toggle_views {
  button {
    height: $input-height;
    @apply rounded-none border-solid border-carbon border-opacity-25 bg-transparent;

    &:hover {
      @apply bg-merino;
    }

    &[class~=Mui-selected] {
      @apply bg-carbon;

      path {
        @apply fill-white;
      }

      &:hover {
        @apply bg-carbon;
      }
    }

    svg {
      max-width: 35px;
      max-height: 35px;
    }
  }
}